import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { H5 } from '@liveauctioneers/hammer-ui-core/text';

import { CategoryModule } from '@/components/CategoryModule/CategoryModule';
import PageTitle from '@/components/PageTitle/PageTitle';
import { getCategoryBrowsePath } from '@/utils/browsePath/itemFacetBrowsePath';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import {
    getAuctionResultsUrl,
    getAuctionsNearMePageUrl,
    getConsignmentsUrl,
    getHomeUrl,
    getSellPageUrl,
    getSupportUrl,
} from '@/utils/urls';

import AboutUsPageHeaderMeta from './AboutUsPageHeaderMeta';

const AboutUsPage = () => {
    const formatMessage = useAppFormatMessage();

    return (
        <div className="mx-auto max-w-[1240px] px-sm pb-lg xsMax:w-full xsMax:max-w-[768px]">
            <AboutUsPageHeaderMeta />
            <PageTitle
                className="mx-auto mt-lg mb-md text-center"
                title={formatMessage(['aboutUs', 'title'])}
            />
            <div className="pt-xs pb-lg">
                <H5 className="mb-md text-center">
                    {formatMessage(['aboutUs', 'content1'], {
                        values: {
                            art: (
                                <Link
                                    className="font-bold"
                                    data-testid="aboutUsArtLink"
                                    href={getCategoryBrowsePath('Art')}
                                    key="about-us-art-link"
                                >
                                    {formatMessage(['navigation', 'art'])}
                                </Link>
                            ),
                            collectibles: (
                                <Link
                                    className="font-bold"
                                    data-testid="aboutUsCollectiblesLink"
                                    href={getCategoryBrowsePath('Collectibles')}
                                    key="about-us-collectibles-link"
                                >
                                    {formatMessage(['navigation', 'collectibles'])}
                                </Link>
                            ),
                            jewelry: (
                                <Link
                                    className="font-bold"
                                    data-testid="aboutUsJewelryLink"
                                    href={getCategoryBrowsePath('Jewelry')}
                                    key="about-us-jewelry-link"
                                >
                                    {formatMessage(['navigation', 'jewelry'])}
                                </Link>
                            ),
                        },
                    })}
                </H5>
                <p>{formatMessage(['aboutUs', 'content2'])}</p>
                <p>{formatMessage(['aboutUs', 'content3'])}</p>
                <p>
                    {formatMessage(['aboutUs', 'content4'], {
                        values: {
                            apps: formatMessage(['aboutUs', 'apps']),
                        },
                    })}
                </p>
                <p>{formatMessage(['aboutUs', 'content5'])}</p>
                <ul>
                    <li>
                        {formatMessage(['aboutUs', 'content6'], {
                            values: {
                                auctionResults: (
                                    <Link
                                        data-testid="auctionResultsDatabaseLink"
                                        href={getAuctionResultsUrl()}
                                        key="about-us-auction-results-database-link"
                                        size="sm"
                                    >
                                        {formatMessage(['main', 'auctionResultsDatabase'])}
                                    </Link>
                                ),
                            },
                        })}
                    </li>
                    <li>
                        {formatMessage(['aboutUs', 'content8'], {
                            values: {
                                consignmentsHub: (
                                    <Link
                                        data-testid="consignmentHubLink"
                                        href={getConsignmentsUrl()}
                                        key="about-us-consignments-hub-link"
                                        size="sm"
                                    >
                                        {formatMessage(['main', 'consignmentsHub'])}
                                    </Link>
                                ),
                            },
                        })}
                    </li>
                </ul>
                <p>
                    {formatMessage(['aboutUs', 'content9'], {
                        values: {
                            browse: (
                                <Link
                                    data-testid="aboutUsBrowseLink"
                                    href={getHomeUrl()}
                                    key="about-us-browse-link"
                                    size="sm"
                                >
                                    {formatMessage(['aboutUs', 'browse'])}
                                </Link>
                            ),
                            nearMe: (
                                <Link
                                    data-testid="auctionsNearMeLink"
                                    href={getAuctionsNearMePageUrl()}
                                    key="about-us-near-me-link"
                                    size="sm"
                                >
                                    {formatMessage(['aboutUs', 'nearMe'])}
                                </Link>
                            ),
                        },
                    })}
                </p>
                <CategoryModule className="my-lg" />
                <p>
                    {formatMessage(['aboutUs', 'content10'], {
                        values: {
                            apply: (
                                <Link
                                    data-testid="aboutUsApplyLink"
                                    href={getSellPageUrl()}
                                    key="about-us-apply-link"
                                    rel="noopener"
                                    size="sm"
                                    target="_blank"
                                >
                                    {formatMessage(['aboutUs', 'apply'])}
                                </Link>
                            ),
                            share: (
                                <Link
                                    data-testid="aboutUsShareLink"
                                    href={getConsignmentsUrl()}
                                    key="about-us-share-link"
                                    size="sm"
                                >
                                    {formatMessage(['aboutUs', 'share'])}
                                </Link>
                            ),
                            support: (
                                <Link
                                    data-testid="aboutUsSupportLink"
                                    href={getSupportUrl()}
                                    key="about-us-support-link"
                                    rel="noopener"
                                    size="sm"
                                    target="_blank"
                                >
                                    {formatMessage(['aboutUs', 'support'])}
                                </Link>
                            ),
                        },
                    })}
                </p>
            </div>
        </div>
    );
};

export default AboutUsPage;
